import { Skeleton } from '@growdash/design-system/atoms';

type Props = {};

export default function LoadingView({}: Props) {
  return (
    <>
      <Skeleton className="rounded-md w-96 h-2 mb-6"></Skeleton>

      <div className="h-7 mb-4">
        <Skeleton className="rounded-md w-48 h-5"></Skeleton>
      </div>

      <div className="grid animate-fade-in grid-cols-12 gap-4">
        <Skeleton className="col-span-full sm:col-span-4 h-[140px]" />
        <Skeleton className="col-span-full sm:col-span-4 h-[140px]" />
        <Skeleton className="col-span-full sm:col-span-4 h-[140px]" />
        <div className="col-span-full ">
          <div className="h-7 mb-4 mt-2">
            <Skeleton className="rounded-md w-64 h-5"></Skeleton>
          </div>
        </div>
        <Skeleton className="col-span-full sm:col-span-6 h-[220px]" />
        <Skeleton className="col-span-full sm:col-span-6 h-[220px]" />

        <Skeleton className="col-span-full h-[260px]" />
      </div>
    </>
  );
}
